"use client";

import useMediaQuery from "@/lib/hooks/useMediaQuery";
import CWFDrawer from "@/components/ui/CWFDrawer";
import CWFDialog from "@/components/ui/CWFDialog";
import {useEffect, useState} from "react";

export default function CWFResponsiveDialog({ children, open: inOpen, onOpenChange, modalLarge, className, ...props }) {

    const [open, setOpen] = useState(false);
    const isDesktop = useMediaQuery("(min-width: 768px)");

    useEffect(() => {
        if (inOpen !== open) {
            setOpen(inOpen);
        }
    }, [inOpen, open]);

    if (isDesktop) {
        return (
            <CWFDialog
                open={open}
                onOpenChange={onOpenChange ?? setOpen}
                modalLarge={modalLarge}
                className={className}
                {...props}
            >
                {children}
            </CWFDialog>
        )
    }

    return (
        <CWFDrawer
            open={open}
            onOpenChange={onOpenChange ?? setOpen}
            {...props}
        >
            {children}
        </CWFDrawer>
    );
}